import TutorialsPage from '../en/tutorials';
export default TutorialsPage;